module.exports = __webpack_public_path__ + "a61b1318dc946e6c3ed5b2c6ed217bde.svg";